module.exports = __webpack_public_path__ + "img/DSC_0021.9b8ee888.jpg";